import {MappedWirtschaftsjahrAngaben, WirtschaftsjahrHelper, WizardPageBaseComponent} from '@utils-lib';
import {Component, OnInit} from '@angular/core';
import {GewinnermittlungAngaben} from '@nachdigal';
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'common-ui-gewinnermittlung-angaben',
    templateUrl: './gewinnermittlung-angaben.component.html'
})
export class GewinnermittlungAngabenComponent extends WizardPageBaseComponent<GewinnermittlungAngaben> implements OnInit {

    static nutzdatenPath = 'gewinnermittlungAngaben';
    static route = 'gewinnermittlung-angaben';

    public wirtschaftsJahrStammdaten: MappedWirtschaftsjahrAngaben;

    constructor(protected readonly activatedRoute: ActivatedRoute) {
        super(activatedRoute);
    }

    public ngOnInit(): void {
        super.ngOnInit();
        this.wirtschaftsJahrStammdaten = WirtschaftsjahrHelper.mapWirtschaftsJahrDaten(this.stammdaten?.unternehmen?.wirtschaftsJahr);
    }

    public onWirtschaftsJahrPicked(): void {
        const wirtschaftsJahr = WirtschaftsjahrHelper.mapWirtschaftsJahrDaten(this.stammdaten?.unternehmen?.wirtschaftsJahr);
        this.data = {
            ...this.data,
            abweichendesWirtschaftsjahr: wirtschaftsJahr?.isAbweichend,
            beginnAbweichendesWirtschaftsjahr: wirtschaftsJahr?.von
        };
    }

    protected getStammdatenMappingRules(): Map<string, unknown | Array<unknown>> {
        const wirtschaftsJahr = WirtschaftsjahrHelper.mapWirtschaftsJahrDaten(this.stammdaten?.unternehmen?.wirtschaftsJahr);
        return new Map<string, unknown | Array<unknown>>([
            ['abweichendesWirtschaftsjahr', wirtschaftsJahr?.isAbweichend],
            ['beginnAbweichendesWirtschaftsjahr', wirtschaftsJahr?.von]
        ]);
    }
}
